import { createComponent } from '@mtfe/sweet';
import { eventBus, common } from '@mtfe/sweet-utils';
import { Toast, MiniRedBagArea, Tabs, RedBagArea, Describe } from '@mtfe/sweet-components';
import { oadLX, autoLogin } from '@mtfe/sweet-oad';
import { receiveOneCoupon, getOnClickEventName } from '../../utils/index';
import store from '../../store/index';
import { COUPON_STATUS } from '../../static/index';
import style from './style.less';
import tpl from './dom.html';
import InnerPoi from '../common/InnerPoi/script';

const { debounce } = common;
const { storeRedBag, storeCommon } = store;
const { RED_BAG_TYPE } = MiniRedBagArea;

const RedBagComponentReady = (defaultActiveTabKey) => {
    eventBus.$on('RedBagComponentReady', () => {
        // 红包组件ready的时候，初始化defaultActiveTabKey对应的商家列表
        eventBus.$emit(getOnClickEventName(defaultActiveTabKey));
    });
};

const describe = new Describe('RedBagComponent', 'waimai_4kttfs5q');
const RedBagComponent = async () => {
    const { isShowRedBag, structInfo, isShowCoupon } = storeCommon;
    const { tabsInfo, effectData, poiData } = storeRedBag;
    const { dom_sg_red_bag: domSgRedBag, dom_wm_red_bag: domWmRedBag } = structInfo.struct;
    const defaultActiveTabKey = tabsInfo[0].recallBizId;

    // const isShowSgRedBag = false; // test code
    // dom展示 && 商家列表不为空 && 有红包的信息
    const isShowSgRedBag =
        domSgRedBag.isShow &&
        poiData[domSgRedBag.recallBizId] &&
        poiData[domSgRedBag.recallBizId].poiList.length > 0 &&
        effectData[domSgRedBag.recallBizId] &&
        effectData[domSgRedBag.recallBizId].giftInfo !== undefined;

    const tabInfo = tabsInfo.map((item) => {
        const { recallBizId } = item;
        const resItem = { ...item, key: recallBizId, label: item.text };
        resItem.innerComponent = InnerPoi({
            listInfo: poiData[recallBizId],
        });
        return resItem;
    });

    const { giftInfo: wmRedBagInfo } = effectData[domWmRedBag.recallBizId];

    const onClickBtnHandler = debounce(async () => {
        const cb = async () => {
            try {
                if (wmRedBagInfo.status !== COUPON_STATUS.STATUS_NEW) return;
                const res = await receiveOneCoupon(wmRedBagInfo.gift_id, domWmRedBag.recallBizId);
                const { rets } = res;
                if (rets[0] === 0) {
                    Toast({ message: '领券成功' });
                    return 'disable';
                }
            } catch (error) {
                console.error(error);
            }
        };
        const autoLoginOptions = {
            cb,
            phone: storeCommon.phone,
            loginSuccessCb: storeCommon.loginSuccessCb,
        };
        const urlParams = {
            redirectDeviceId: storeCommon.deviceId,
        };
        return autoLogin(autoLoginOptions, urlParams);
    }, 500);

    const data = {
        isShowSgRedBag,
        tabs: Tabs({
            tabInfo,
            defaultActiveTabKey,
            onTabBarClick: (key) => {
                const eventName = getOnClickEventName(key);
                eventBus.$emit(eventName);
            },
            stickMargin: isShowCoupon && isShowRedBag ? 150 : 0,
            oadLX,
        }),

        redBagArea: await RedBagArea({
            title: wmRedBagInfo.desc,
            value: wmRedBagInfo.coupon_amount / 100,
            threshold: wmRedBagInfo.order_amount_limit / 100,
            subtitle: '红包专区商家均可使用,与商家满减、折扣同享',
            canReceive: wmRedBagInfo.status === COUPON_STATUS.STATUS_NEW,
            onClickBtn: onClickBtnHandler,
        }),
        wmRedBagArea: '',
        sgRedBagArea: '',
    };
    if (isShowSgRedBag) {
        const { giftInfo: sgRedBagInfo } = effectData[domSgRedBag.recallBizId];

        const wmOnBtnRecvClickHandler = debounce(async () => {
            const cb = async () => {
                try {
                    if (wmRedBagInfo.status !== COUPON_STATUS.STATUS_NEW) return;
                    const res = await receiveOneCoupon(
                        wmRedBagInfo.gift_id,
                        domWmRedBag.recallBizId,
                    );
                    const { rets } = res;
                    if (rets[0] === 0) {
                        Toast({ message: '领券成功' });
                        return 'disable';
                    }
                } catch (error) {
                    console.error(error);
                }
            };

            const autoLoginOptions = {
                cb,
                phone: storeCommon.phone,
                loginSuccessCb: storeCommon.loginSuccessCb,
            };
            const urlParams = {
                redirectDeviceId: storeCommon.deviceId,
            };
            return autoLogin(autoLoginOptions, urlParams);
        }, 500);
        data.wmRedBagArea = MiniRedBagArea({
            title: '外卖红包',
            amount: wmRedBagInfo.coupon_amount / 100,
            threshold: wmRedBagInfo.order_amount_limit / 100,
            canReceive: wmRedBagInfo.status === COUPON_STATUS.STATUS_NEW,
            redBagType: RED_BAG_TYPE.WAIMAI,
            onBtnRecvClick: wmOnBtnRecvClickHandler,
        });
        const sgOnBtnRecvClickHandler = debounce(async () => {
            const cb = async () => {
                try {
                    if (sgRedBagInfo.status !== COUPON_STATUS.STATUS_NEW) return;
                    const res = await receiveOneCoupon(
                        sgRedBagInfo.gift_id,
                        domSgRedBag.recallBizId,
                    );
                    const { rets } = res;
                    if (rets[0] === 0) {
                        Toast({ message: '领券成功' });
                        return 'disable';
                    }
                } catch (error) {
                    console.error(error);
                }
            };
            const autoLoginOptions = {
                cb,
                phone: storeCommon.phone,
                loginSuccessCb: storeCommon.loginSuccessCb,
            };
            const urlParams = {
                redirectDeviceId: storeCommon.deviceId,
            };
            return autoLogin(autoLoginOptions, urlParams);
        }, 500);
        data.sgRedBagArea = MiniRedBagArea({
            title: '商超果蔬红包',
            amount: sgRedBagInfo.coupon_amount / 100,
            threshold: sgRedBagInfo.order_amount_limit / 100,
            canReceive: sgRedBagInfo.status === COUPON_STATUS.STATUS_NEW,
            redBagType: RED_BAG_TYPE.SHANGOU,
            onBtnRecvClick: sgOnBtnRecvClickHandler,
        });
    }
    const events = {};
    RedBagComponentReady(defaultActiveTabKey);
    const component = createComponent(tpl, { data, style }, events);
    return component;
};

RedBagComponent.describe = describe;
export default RedBagComponent;
